import React from 'react';
import { motion } from 'framer-motion';
interface ScrollRevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  duration?: number;
}
export function ScrollReveal({
  children,
  className = '',
  delay = 0,
  direction = 'up',
  duration = 0.6
}: ScrollRevealProps) {
  const getInitialY = () => {
    if (direction === 'up') return 40;
    if (direction === 'down') return -40;
    return 0;
  };
  const getInitialX = () => {
    if (direction === 'left') return 40;
    if (direction === 'right') return -40;
    return 0;
  };
  return <motion.div initial={{
    opacity: 0,
    y: getInitialY(),
    x: getInitialX()
  }} whileInView={{
    opacity: 1,
    y: 0,
    x: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration,
    delay,
    ease: [0.21, 0.47, 0.32, 0.98] // Custom ease-out cubic
  }} className={className} data-id="element-87">
      {children}
    </motion.div>;
}